<template>
  <div>
    <h1 class="page-header">{{ $t('calculatePayroll.payrollCalculation') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6 d-flex justify-content-start">
            <ts-button
              color="info"
              outline
              @click="showForm()"
            >{{ $t('calculatePayroll.calculatePayroll') }}</ts-button>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-date-picker-input v-model="cycle_year" format="YYYY"></ts-date-picker-input>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-date-picker-input v-model="cycle_month" format="MM"></ts-date-picker-input>
          </div>
          <div class="col-sm-12 col-md-2 col-lg-2">
            <ts-input style="width:100%" v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'cycle_month'
        }"
      >
        <template v-slot="{ record, index }">
          <td>{{ record.calculated_by }}</td>
          <td class="text-center">{{ record.cycle_order }}</td>
          <td>{{ record.remarks }}</td>
          <td class="text-center">{{ record.calculated_date }}</td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'
import moment from 'moment'

export default {
  name: 'calculate-payroll',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/calculatePayroll', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.calculatePayroll.search
      },
      set(newValue) {
        this.$store.commit('hr/calculatePayroll/SET_SEARCH', newValue)
        this.$store.commit('hr/calculatePayroll/RESET_CURRENT_PAGE')
      }
    },
    cycle_month: {
      get() {
        return this.$store.state.hr.calculatePayroll.cycle_month
      },
      set(newValue) {
        this.$store.commit('hr/calculatePayroll/SET_CYCLE_MONTH', newValue)
      }
    },
    cycle_year: {
      get() {
        return this.$store.state.hr.calculatePayroll.cycle_year
      },
      set(newValue) {
        this.$store.commit('hr/calculatePayroll/SET_CYCLE_YEAR', newValue)
      }
    },
    columns() {
      return [
        {
          name: this.$t('calculatePayroll.calculatedBy')
        },
        {
          name: this.$t('calculatePayroll.cycleOrder'),
          style: 'text-align:center; width: 12%;'
        },
        {
          name: this.$t('calculatePayroll.remarks')
        },
        {
          name: this.$t('calculatePayroll.createdDate'),
          style: 'text-align:center; width: 15%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/calculatePayroll/fetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '30%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    cycle_year: function(cycleYear) {
      this.fetchData()
    },
    cycle_month: function(cycleMonth) {
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/calculatePayroll/RESET_STATE')
    this.$store.commit('hr/calculatePayroll/SET_ORG_CHART_STRUCTURES', [])
    next()
  }
}
</script>
